import { Highlight } from 'react-instantsearch';

import type { MediaProps } from '#/lib/sanity';
import { Link } from '#/components/Link';
import { Media } from '#/components/Media';

export function BlogPostHit({
  hit,
  mediaSizes,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hit: any;
  mediaSizes: MediaProps['sizes'];
}) {
  return (
    <Link href={hit.href} className="block">
      <Media
        media={hit.image}
        className="aspect-[16/9] rounded-16"
        aspect={false}
        placeholder={true}
        sizes={mediaSizes}
      />
      <h4 className="mt-15 text-pretty text-22 font-[440] leading-116 -tracking-1 m:mt-20 m:text-28">
        <Highlight attribute="title" hit={hit} />
      </h4>
      <p className="mt-8 text-pretty text-grayscale-06 m:mt-10">
        <Highlight attribute="description" hit={hit} />
      </p>
      <p className="mt-10 flex text-12 text-grayscale-05 m:mt-15 l:text-14">
        {new Date(hit.publishedAt).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })}
        {hit.readTime ? (
          <>
            <span className="px-7">•</span>
            {hit.readTime} min read
          </>
        ) : null}
      </p>
    </Link>
  );
}
